module.exports = __webpack_public_path__ + "img/cgn.a90ab273.jpg";